module.exports = __webpack_public_path__ + "assets/media/mail.a92f6db3.mp3";